import React, { createElement } from 'react';
import chunk from 'lodash/chunk';
import Style from './index.module.scss';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng-fe/lowcode_tool/src/method/common'
import { FormatImage } from '@ifeng-fe/lowcode_tool/src/components/FormatImage'
import Chip from 'Chip';

export interface NewsList_12_Props {
    // 通用样式
    nodeId: string;
    style: object;
    newsChip: TYPE_Chip; // 数据源
    colNum: number; // 列数
    thumbnailWidth: number;
    thumbnailHeight: number;
    showThumbnailHoverScale: boolean;
    formatImageType: 0 | 1 | 2 | 3;

    // 单条样式
    itemStyle: object

    // 标题
    isHasTitle: boolean
    titleRows: number
    titleHeight: number
    titleStyle: object;
    titleHoverColor: string;

    // 描述
    showSummary: boolean
    summaryRows: number
    summaryHeight: number
    summaryStyle: object
    moreText: string
    moreStyle: object
}

const NewsList_12: React.FC<NewsList_12_Props> = (props: NewsList_12_Props) => {
    const {
        nodeId, style, newsChip, colNum, thumbnailWidth, thumbnailHeight, showThumbnailHoverScale, formatImageType,
        itemStyle,
        isHasTitle, titleRows, titleHeight, titleStyle, titleHoverColor,
        showSummary, summaryRows, summaryHeight, summaryStyle, moreText, moreStyle
    } = props;

    const newsChipData = useChip(newsChip as TYPE_Chip);
    const chipComponentData = formatChip(newsChip);
    let rowList = [];

    if (newsChipData && Array.isArray(newsChipData) && newsChipData.length) {
        rowList = chunk(newsChipData, colNum);

        const lastIndex = rowList.length - 1;
        const lastRow = rowList[lastIndex];
        const lastRowLength = lastRow.length;

        if (lastRowLength < colNum) {
            for (let i = 0; i < colNum - lastRowLength; i++) {
                lastRow.push({ empty: true });
            }
        }
    }

    return (
        <div id={nodeId} className={Style.wrap} style={style}>
            <Chip {...chipComponentData}>
                <div className={Style.list}>
                    {rowList.map((row) => {
                        return (
                            <div className={Style.row}>
                                {row.map((col) => {
                                    const { empty, title, url, summary } = col;


                                    return (
                                        // @ts-ignore
                                        <div className={Style.col} style={ empty? { width: thumbnailWidth } : {width: thumbnailWidth, '--hover-color': titleHoverColor, ...itemStyle}}>
                                            {!empty ? (
                                                <a
                                                    href={url}
                                                    target="_blank"
                                                    className={Style.colLink}
                                                >
                                                    <div
                                                        className={`${Style.thumbnail} ${
                                                            showThumbnailHoverScale
                                                                ? Style.thumbnailHoverScale
                                                                : ''
                                                        }`}
                                                        style={{
                                                            width: thumbnailWidth,
                                                            height: thumbnailHeight,
                                                        }}
                                                    >
                                                        <FormatImage src={getThumbnailFromRecommend(col)} formatType={formatImageType} formatWidth={thumbnailWidth} formatHeight={thumbnailHeight} />
                                                    </div>
                                                    {
                                                        isHasTitle &&
                                                        <div className={Style.title} style={{ height: titleHeight ? `${titleHeight}px` : 'auto', ...titleStyle }}>
                                                            <span style={{ WebkitLineClamp: titleRows }}>{title}</span>
                                                        </div>
                                                    }
                                                    {
                                                        showSummary &&
                                                        <div className={Style.summary} style={{ height: summaryHeight ? `${summaryHeight}px` : 'auto', ...summaryStyle }}>
                                                            <span className={Style.summaryContent} style={{ WebkitLineClamp: summaryRows }}>{summary}</span>
                                                            {moreText && <span className={Style.more} style={{ ...moreStyle }}>{moreText}</span>}
                                                        </div>
                                                    }
                                                </a>
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </Chip>
            <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
        </div>
    );
};

export default NewsList_12;
